import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  width?: string;
  height?: string;
  animated?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonText',
  props: {
    width: { default: '100px' },
    height: { default: '1.2em' },
    animated: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["skeleton-text", { 'skeleton-text--animated': _ctx.animated }]),
    style: _normalizeStyle({ width: _ctx.width, height: _ctx.height })
  }, null, 6))
}
}

})